import { render, staticRenderFns } from "./Notifications.html?vue&type=template&id=30dce401&scoped=true&external"
import script from "./Notifications.js?vue&type=script&lang=js&external"
export * from "./Notifications.js?vue&type=script&lang=js&external"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=30dce401&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dce401",
  null
  
)

export default component.exports